Ext.define('SA.VectorMapExportPreview', {
    alias: 'widget.vector-map-export-preview',
    extend: 'Ext.container.Container',

    cls: 'sa-export-preview',

    layout: {
        align: 'middle',
        pack: 'center',
        type: 'hbox'
    },

    listeners: {
        resize(me) {
            me.refresh();
        }
    },

    initComponent() {
        this.items = [{
            xtype: 'vector-map-export-preview-page',
            details: this.details,
            map: this.map
        }];

        this.refresh = SA.createBuffered(this.refresh, 10);

        this.callParent();
    },

    afterRender() {
        this.callParent();

        this.mon(this.details, {
            'set:height': this.refresh,
            'set:width': this.refresh,

            scope: this
        });

        this.el.unselectable();
    },

    refresh() {
        var page = this.down('vector-map-export-preview-page'),
            el = this.el,
            margin = 20,
            availableHeight = el.getHeight() - 2 * margin,
            availableWidth = el.getWidth() - 2 * margin,
            details = this.details,
            ratio = details.getHeight() / details.getWidth();

        page.setSize(SA.restrictSizeByRatio({
            height: availableHeight,
            width: availableWidth
        }, ratio));

        page.refresh();
    }
});